export default {

    container: '<div class="uwr-dropdown-container" tabindex="0"></div>',
    content: ['<span class="uwr-dropdown-content">',
        '<span class="uwr-dropdown-arrow-icon"></span>',
        '<span class="uwr-dropdown-bottom-label">{{labelBeforeSelect}}</span>',
        '<span class="uwr-dropdown-bottom-label-after-select uwr-dropdown-hidden-element">',
            '{{labelAfterSelect}}',
        '</span>',
        '<span class="uwr-dropdown-selected-value"></span>',
    '</span>',
    '<div class="uwr-dropdown-options">',
        '<span class="uwr-dropdown-top-label">{{labelBeforeSelect}}</span>',
        '{{#searchEnabled}}',
            '<input class="uwr-input">',
        '{{/searchEnabled}}',
        '<ul class="uwr-dropdown-option-list">',
        '</ul>',
        '<div class="uwr-dropdown-message"></div>',
    '</div>'
    ].join(''),
    options: [
        '{{#optionElements}}',
            '<li class="uwr-dropdown-item">{{.}}</li>',
        '{{/optionElements}}'
        ].join(''),
    multiSelected: [
        '{{#optionElements}}',
            '<span class="uwr-dropdown-multi-selected" tabindex="0">{{.}}</span>',
        '{{/optionElements}}'
        ].join(''),
    message: [
        '{{#noMatch}}',
            '<span class="uwr-dropdown-no-match">No results match "{{searchPattern}}"</span>',
        '{{/noMatch}}'
    ].join('')
};



//////////////////
// WEBPACK FOOTER
// ./widgets/Dropdown/js/dropdownView.js
// module id = 88
// module chunks = main